import { useFormContext } from 'react-hook-form';
import React from 'react';
import { RadixHoverDropdown } from '@/components/custom/erp';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

const OtherTab: React.FC = () => {
  return (
    <div className='h-28 w-[800px] min-w-[800px] space-y-2 p-4'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Mẫu lọc báo cáo:</Label>
        <div className='flex items-center gap-2'>
          <FormField
            name='report_filtering'
            type='select'
            options={[{ value: '1', label: 'Người dùng tự lọc' }]}
            className='w-96'
          />

          <div className='h-9 w-9 flex-shrink-0'>
            {/* Fixed size container */}
            <RadixHoverDropdown
              iconNumber={624}
              items={[
                {
                  value: 'save_new',
                  label: 'Lưu mẫu mới',
                  icon: 7,
                  onClick: () => undefined
                },
                {
                  value: 'save_overwrite',
                  label: 'Lưu đè vào mẫu đang chọn',
                  icon: 75,
                  onClick: () => console.log('Overwrite current filter template')
                },
                {
                  value: 'delete',
                  label: 'Xóa mẫu đang chọn',
                  icon: 8,
                  onClick: () => console.log('Delete current filter template')
                }
              ]}
            />
          </div>
        </div>
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Mẫu phân tích DL</Label>
        <div className='flex flex-1 items-center gap-2'>
          <div className='w-96'>
            <FormField name='data_analysis_struct' type='select' options={[{ value: '0', label: 'Không phân tích' }]} />
          </div>
          <div className='size-9 flex-shrink-0'>
            {/* Fixed size container */}
            <RadixHoverDropdown
              iconNumber={873}
              items={[
                {
                  value: 'save_new',
                  label: 'Tạo mới mẫu phân tích',
                  icon: 7,
                  onClick: () => undefined
                },
                {
                  value: 'save_overwrite',
                  label: 'Lưu đè vào mẫu đang chọn',
                  icon: 75,
                  onClick: () => console.log('Overwrite current template')
                },
                {
                  value: 'delete',
                  label: 'Xóa mẫu đang chọn',
                  icon: 8,
                  onClick: () => console.log('Delete current template')
                }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherTab;
